import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultichannelActionStateSelected
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionStateSelected/SelectMultichannelActionStateSelected'
import SelectMultichannelActionStateSelectedIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionStateSelected/SelectMultichannelActionStateSelected'
import {
  saveActionDeviceStateInfo,
  saveActionType,
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
} from '@app/actions/scenes/currentSceneCreating'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMultichannelActionStateSelectedIOS) : withStyles(SelectMultichannelActionStateSelected)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { name: subDeviceName, number: subDeviceNumber } = state.scenes.currentSceneCreating.currentAction.currentSubDevice
  const {
    stateDescription,
    actionDeviceNumber,
    durationDescription,
    durationValueAfter,
    duration: actionDuration,
  } = state.scenes.currentSceneCreating.currentAction
  const { isEditActionMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    stateDescription,
    isEditActionMode,
    actionDeviceNumber,
    durationDescription,
    durationValueAfter,
    actionDuration,
    subDeviceName,
    subDeviceNumber,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionDeviceStateInfo,
  saveActionType,
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultichannelActionStateSelectedEnhanced = enhance

export default withRouter(SelectMultichannelActionStateSelectedEnhanced)
